import { useMemo } from 'react'

import useSortForm from './useSortForm'
import useVaultsList from './useVaultsList'
import useVaultsCount from './useVaultsCount'


const useVaults = () => {
  const {
    sort,
    search,
    filter,
    sortForm,
  } = useSortForm()

  const {
    vaults,
    blacklistTotal,
    isFetching: isVaultsFetching,
    fetchNextItems,
  } = useVaultsList({ sort, filter, search, sortForm })

  const {
    total,
    filterTabs,
    isFetching: isVaultsCountFetching,
  } = useVaultsCount({ filter: filter || 'all', blacklistTotal })

  const isFetching = !search && (isVaultsFetching || isVaultsCountFetching)

  return useMemo(() => ({
    total,
    filter,
    vaults,
    sortForm,
    filterTabs,
    isFetching: !search && isFetching,
    fetchNextItems,
  }), [
    total,
    search,
    filter,
    vaults,
    sortForm,
    filterTabs,
    isFetching,
    fetchNextItems,
  ])
}


export default useVaults
